class FeaturedBlogMobile extends HTMLElement {
  constructor() {
    super();

    this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    this.handleImageClick = this.handleImageClick.bind(this);
  }

  connectedCallback() {
    this.slider = this.querySelector('.slider');
    this.slides = Array.from(this.querySelectorAll('.blog__post'));
    this.images = Array.from(this.querySelectorAll('.article-card__image'));

    if (!this.slider || this.slides.length === 0 || this.images.length === 0)
      return;

    this.bindEvents();
  }

  disconnectedCallback() {
    this.images.forEach((image) => {
      image.removeEventListener('click', this.handleImageClick);
    });
  }

  bindEvents() {
    this.images.forEach((image) => {
      image.addEventListener('click', this.handleImageClick);
    });
  }

  isMobileViewport() {
    return this.mobileMediaQuery.matches;
  }

  getVisibleSlides() {
    const scrollerRect = this.slider.getBoundingClientRect();

    return this.slides.filter((slide) => {
      const rect = slide.getBoundingClientRect();
      return (
        rect.right > scrollerRect.left + 2 && rect.left < scrollerRect.right - 2
      );
    });
  }

  getScrollStep(slide) {
    const gap =
      Number.parseFloat(getComputedStyle(this.slider).columnGap) ||
      Number.parseFloat(getComputedStyle(this.slider).gap) ||
      0;

    return slide.getBoundingClientRect().width + gap;
  }

  getMaxScrollLeft() {
    return Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
  }

  activateSlide(slide) {
    const visibleSlides = this.getVisibleSlides();
    const firstVisible = visibleSlides[0];
    const lastVisible = visibleSlides[visibleSlides.length - 1];
    const maxScrollLeft = this.getMaxScrollLeft();
    const step = this.getScrollStep(slide);

    if (slide === lastVisible && maxScrollLeft > 0) {
      this.slider.scrollTo({
        left: Math.min(maxScrollLeft, this.slider.scrollLeft + step),
        behavior: 'smooth',
      });
      return;
    }

    if (slide === firstVisible && this.slider.scrollLeft > 0) {
      this.slider.scrollTo({
        left: Math.max(0, this.slider.scrollLeft - step),
        behavior: 'smooth',
      });
    }
  }

  handleImageClick(event) {
    if (!this.isMobileViewport()) return;
    if (event.target.closest('.article-card__info')) return;

    event.preventDefault();
    event.stopPropagation();

    const slide = event.currentTarget.closest('.blog__post');
    if (!slide) return;

    this.activateSlide(slide);
  }
}

customElements.define('featured-blog-mobile', FeaturedBlogMobile);
